import * as marietta from '../..';

export default class MiniMapCurrent {
  point: marietta.core.Point = new marietta.core.Point(0, 0);

  rotation: number = 0;

  viewObj: HTMLCanvasElement;

  ua: marietta.webcad.manager.UserAgentManager;

  /**
   * コンストラクタ
   */
  constructor(type: number) {
    this.ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (document.getElementById('topview_current')) {
      document.getElementById('topview_current').remove();
    }
    const destId = 'topview_current';

    // 表示するCanvasの作成
    const canvas = document.createElement('canvas');
    canvas.setAttribute('id', destId);
    canvas.style.display = 'block';
    canvas.style.cursor = 'pointer';

    if (this.ua.isPC) {
      canvas.width = 87; // アイコンのサイズ
      canvas.height = 87; // アイコンのサイズ
    } else if (this.ua.isTablet) {
      canvas.width = 87 * 2; // アイコンのサイズ
      canvas.height = 87 * 2; // アイコンのサイズ
    } else {
      canvas.width = 87; // アイコンのサイズ
      canvas.height = 87; // アイコンのサイズ
    }
    // canvasに読み込む画像データを設定
    const ctx = canvas.getContext('2d');
    const image = new Image();
    let url = marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url;
    if (this.ua.isPC) {
      url += 'current_place.png';
    } else if (this.ua.isTablet) {
      url += 'current_place_dpr2.png';
    } else {
      url += 'assets/current_place.png';
    }

    image.src = url;
    image.crossOrigin = 'Anonymous';
    const self = this;
    image.onload = () => {
      ctx.drawImage(image, 0, 0);
      self.viewObj = canvas;

      if (type === 0)document.getElementById('topview').append(canvas);
    };
  }

  /**
   * 削除
   */
  remove() {
    if (!this.viewObj) return;
    this.viewObj.remove();
  }

  /**
   * 移動
   */
  move(x: number, y: number) {
    this.point.x = x;
    this.point.y = y;
    this.setTransformUpdate();
  }

  /**
   * 回転
   */
  rotate(radian: number) {
    this.rotation = radian;
    this.setTransformUpdate();
  }

  /**
   * アップデート
   */
  setTransformUpdate() {
    if (!this.viewObj) return;
    const r = this.rotation;
    let dx; let dy;
    if (this.ua.isPC) {
      dx = this.point.x;
      dy = this.point.y;
    } else if (this.ua.isTablet) {
      dx = this.point.x / 2;
      dy = this.point.y / 2;
    } else {
      dx = this.point.x / 2 + 11;
      dy = this.point.y / 2 + 11;
    }
    let matrix = '';
    matrix += 'matrix(';
    matrix += `${String(Math.cos(r))},`;
    matrix += `${String(-Math.sin(r))},`;
    matrix += `${String(Math.sin(r))},`;
    matrix += `${String(Math.cos(r))},`;
    matrix += `${String(dx)},`;
    matrix += `${String(dy)})`;
    this.viewObj.style.transform = matrix;
  }
}
